import React from 'react';

import Desktop from './components/Desktop';
import Mobile from './components/Mobile';
import useCurrentBreakpoint from '~/hooks/useCurrentBreakpoint';

export type StepBase = {
  id: string;
  label: React.ReactNode;
  disabled: boolean;
};

export type Step = StepBase & { subSteps?: Array<StepBase> };

export type Props = {
  steps: Array<Step>;
  currentStep: number;
  currentSubStep?: number | null;
};

const StepList: React.FCC<Props> = (props: Props) => {
  const currentBp = useCurrentBreakpoint();

  switch (currentBp) {
    case 'mobile':
      return <Mobile {...props} />;
    default:
      return <Desktop {...props} />;
  }
};

export default StepList;
